export default __webpack_public_path__ + "6e7a3ec6ec3baa373d76ff0a55f2cfaa.png";